<template src="./main.html"></template>

<script>
import ToolBar from "@/components/layout/ToolBar";
import LeftBar from "@/components/layout/LeftBar";
import BannerImpersonificazione from "@/components/layout/BannerImpersonificazione"; // NUOVO
import storage from "@/services/storage.js";

export default {
  name: "MainPage",
  components: {
    ToolBar,
    LeftBar,
    BannerImpersonificazione
  },

  data() {
    return {
      menu: [],
      disabilitaBtn: false,
      drawer: true,
      pollNotifiche: null,
    };
  },

  computed: {
    loading() {
      return this.$store.state.app.loading;
    },
    utente() {
      return this.$store.getters["user/getNome"];
    },
    mail() {
      return this.$store.getters["user/getMail"];
    },
    logoUrl() {
      return this.$store.getters["miaAzienda/logoUrl"];
    },
    isEmbed() {
      return storage.isEmbedMode();
    },
  },

  mounted() {
    this.init();
    // Aggiorna il badge notifiche periodicamente: niente WebSocket/SignalR in
    // questo progetto, un polling leggero ogni 5 minuti è sufficiente per un
    // contatore non critico in tempo reale.
    this.pollNotifiche = setInterval(() => {
      this.$store.dispatch("notifiche/caricaConteggio");
    }, 5 * 60 * 1000);
  },

  beforeUnmount() {
    if (this.pollNotifiche) clearInterval(this.pollNotifiche);
  },

  methods: {
    async init() {
      try {
        const res = await this.$store.dispatch("user/userInfo");
        this.menu = res.data.menu;
      } catch (error) {
        console.log(error);
      }

      // Logo del tenant per la sidebar: nessun errore da gestire se assente (es.
      // SuperAdmin senza azienda propria, o nessun logo ancora caricato) — vedi
      // miaAzienda/caricaLogo, che risolve a null in quei casi.
      this.$store.dispatch("miaAzienda/caricaLogo");

      // Conteggio notifiche non lette per il badge in toolbar.
      this.$store.dispatch("notifiche/caricaConteggio");
    },

    async esci() {
      this.disabilitaBtn = true;
      try {
        await this.$store.dispatch("auth/logout");
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>